import React from 'react';
import { ellipsisMixin } from '../../theme/utils';
import { HudIcon } from '../../Icons/HudIcons';
import styled from 'styled-components';

export type NodeTitleProps = {
  title: string;
  icon?: React.ReactNode;
  path?: string;
  service?: string;
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const WithEllipsis = styled.div`
  ${ellipsisMixin}
`;

export const NodeTitleWithIconContainer = ({
  title,
  icon,
  path,
  service,
}: NodeTitleProps) => {
  return (
    <Container>
      {icon}
      <WithEllipsis>{title}</WithEllipsis>
      {path && <WithEllipsis>{path}</WithEllipsis>}
      {service && (
        <>
          <HudIcon icon="entities.servicesBlank" />
          <div>{service}</div>
        </>
      )}
    </Container>
  );
};
